<div class="c-menu-list" [ngClass]="cssClass">
  <div class="c-menu-list__title" i18n="@@common.profile_panel">Profile panel</div>
  <div class="c-menu-list__content">
    <li *ngIf="!rbacService.can(RbacPermissionsConstant.PAGES_SPECIAL_ALLOW_SENSITIVE_DATA_VIEW)" class="c-menu-list__item">
      <p500-ui-slide-toggle-field [formControl]="unsecuredModeControl" [isLabelRight]="true" size="medium">
        <ng-template p500UIFieldLabel>
          <small class="c-menu-list__label" i18n="@@common.unsecured_mode">Unsecured Mode</small>
        </ng-template>
      </p500-ui-slide-toggle-field>
    </li>
    <li class="c-menu-list__item">
      <a [routerLink]="['/app/account-protection']" class="d-flex">
        <p500-ui-icon name="pencil h-icon"> </p500-ui-icon>
        <ng-container i18n="@@common.edit_profile">Edit Profile</ng-container>
      </a>
    </li>
    <div class="c-menu-list__item -red d-flex" (click)="logout()">
      <p500-ui-icon name="log-out h-icon"> </p500-ui-icon>
      <ng-container i18n="@@common.log_out">Log out</ng-container>
    </div>
  </div>
</div>
